import React from "react";
import { Button, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
  success: {
    border: "2px solid #09C491",
    color: "#09C491",
    background: "#09C49129",
    "&:hover": {
      background: "rgba(102, 255, 217, 0.5)",
    },
    disabledStyle: {
      cursor: "not-allowed",
    },
  },
  danger: {
    border: "2px solid #ff1a1a",
    color: "#ff1a1a",
    background: "rgba(255, 181, 179, 0.4)",
    "&:hover": {
      background: "rgba(255, 132, 128, 0.5)",
    },
    disabledStyle: {
      cursor: "not-allowed",
    },
  },
  warning: {
    border: "2px solid #ffc34d",
    color: "#ffc34d",
    background: "rgba(255, 230, 179, 0.4)",
    "&:hover": {
      background: "rgba(255, 230, 179, 0.5)",
    },
    disabledStyle: {
      cursor: "not-allowed",
    },
  },
  faded: {
    border: "2px solid #445B6E",
    color: "#445B6E",
    background: "#DCE5EC",
    "&:hover": {
      background: "#cddae4",
    },
    disabledStyle: {
      cursor: "not-allowed",
    },
  },
  secondaryButton: {
    background: "#d9d9d9",
    "&:hover": {
      background: "#d9d9d9",
    },
    borderRadius: 10,
  },
  disabledStyle: {
    cursor: "not-allowed",
  },
}));

export const PrimaryButton = ({
  type,
  rounded,
  size,
  children,
  fullWidth,
  handleClick,
  disabled,
  style,
  href,
  testId,
}) => {
  const classes = useStyles();
  return (
    <>
      {rounded ? (
        <>
          <IconButton
            href={href}
            target="_blank"
            className={clsx(
              classes[type ? type.toLowerCase() : "success"],
              disabled && classes.disabledStyle
            )}
            size={size}
            onClick={handleClick}
            disabled={disabled}
          >
            {children}
          </IconButton>
        </>
      ) : (
        <>
          <Button
            data-testid={testId}
            href={href}
            style={style}
            className={clsx(
              classes[type ? type.toLowerCase() : "success"],
              disabled && classes.disabledStyle
            )}
            size={size}
            fullWidth={fullWidth}
            onClick={handleClick}
            disabled={disabled}
          >
            {children}
          </Button>
        </>
      )}
    </>
  );
};
